// extracted by mini-css-extract-plugin
module.exports = {"button":"IconButton_button__2xgfI"};